"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.getReseller = void 0;
const utils_1 = require("../../utils");
const configCat_1 = require("../configCat");
const SessionControl_1 = require("../../utils/helpers/session/SessionControl");
function parseRequestParams(params) {
    const mapperKeys = {
        resellerSlug: 'catalogSlug',
    };
    return Object.entries(params).reduce((prev, [key, value]) => {
        const newKey = mapperKeys[key] || key;
        return Object.assign(Object.assign({}, prev), { [newKey]: value });
    }, {});
}
function getUrl(params) {
    return __awaiter(this, void 0, void 0, function* () {
        const resellerMigrationKey = 'migrate_reseller_to_bff';
        const flag = yield (0, configCat_1.getValueConfigCat)({
            key: resellerMigrationKey,
            default: false,
            userIdentifier: SessionControl_1.User.getInstance().getUserId(),
        });
        const urlBFF = '/catalog/bff/reseller/';
        if (flag || 'resellerDocument' in params) {
            return urlBFF;
        }
        let key = '';
        if ('resellerSlug' in params) {
            key = params.resellerSlug;
        }
        else if ('resellerId' in params) {
            key = params.resellerId;
        }
        return `/catalog/reseller/${key}/`;
    });
}
const getReseller = (params) => __awaiter(void 0, void 0, void 0, function* () {
    if ('resellerSlug' in params && (0, utils_1.isGenericReseller)(params.resellerSlug))
        throw new Error(`Reseller should not be generic one. Pass a value different of ${utils_1.envConfig.genericUrl}.`);
    const headers = {};
    if (params.businessUnit) {
        headers['x-business-unit'] = params.businessUnit;
    }
    const url = yield getUrl(params);
    return utils_1.apiClient
        .get(url, {
        params: parseRequestParams(params),
        headers: headers,
    })
        .then((response) => response.data);
});
exports.getReseller = getReseller;
